import { WEDDING_STORIES } from "../../data/content";
import { Link } from "react-router-dom";
import { Chapter, Reveal, Btn } from "../shared";

export default function Stories() {
  return (
    <section className="bg-ivory py-24 md:py-32" data-testid="real-weddings">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Chapter num="06" title="Real Weddings" />
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-2xl font-serif text-4xl md:text-6xl leading-[1.05] text-emerald">
            Real weddings, <span className="italic text-gold-text">real stories</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-10 md:grid-cols-2">
          {WEDDING_STORIES.slice(0, 4).map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.12}>
              <Link to={`/weddings/${s.slug}`} className="group block" data-testid={`wedding-story-card-${i}`}>
                <article>
                  <div className="relative overflow-hidden">
                    <img src={s.cover} alt={`${s.couple} — ${s.venue}`} loading="lazy" className="h-[320px] md:h-[460px] w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink/40 to-transparent opacity-60" />
                    <span className="absolute left-5 top-5 bg-ivory/90 px-4 py-1.5 text-[10px] uppercase tracking-[0.25em] text-emerald">{s.style}</span>
                  </div>
                  <div className="border-x border-b border-gold/25 p-6 md:p-8 bg-white/60">
                    <h3 className="font-serif text-3xl md:text-4xl text-emerald">{s.couple} <span className="text-gold">—</span> <span className="italic">{s.venue}</span></h3>
                    <p className="mt-4 text-sm md:text-base leading-relaxed text-stone2">“{s.story}”</p>
                    <span className="mt-5 inline-flex items-center gap-3 border-b border-gold pb-1 text-[11px] font-medium uppercase tracking-[0.25em] text-emerald transition-colors group-hover:text-gold-text">
                      Read their story <span className="transition-transform duration-300 group-hover:translate-x-2">→</span>
                    </span>
                  </div>
                </article>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-14 text-center">
          <Btn to="/gallery" variant="outline" testid="stories-cta">View More Weddings</Btn>
        </Reveal>
      </div>
    </section>
  );
}
